import React, { useEffect } from "react";

const SelectOption = ({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = "Select option",
  className = "",
}) => {

  useEffect(() => {
    if (!value && options.length) {
      onChange({ target: { value: options[0].value } });
    }
  }, [options]);

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label className="block mb-1 text-sm font-medium text-gray-700">
          {label}
        </label>
      )}

      <div className="relative">
        <select
          name={name}
          value={value ?? ""}
          onChange={onChange}
          className="appearance-none w-full bg-white border-2 border-gray-400 text-gray-900 font-medium text-base rounded-lg px-4 py-2 pr-10 hover:shadow-sm transition duration-200 outline-none focus:ring-gradient-to-r from-[#673AB7] to-[#1976D2] hover:border-indigo-400">
          <option value="" disabled>
            {placeholder}
          </option>

          {options?.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        {/* Dropdown Icon */}
        <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-400">
          <svg className="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">  <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" clipRule="evenodd" /></svg>
        </div>
      </div>
    </div>
  );
};

export default SelectOption;